import { gsap } from '../global/gsap';

const initServiceNav = (section) => {
    const buttons = section.querySelectorAll('button');
    const scrollToEl = (target) => {
        const targetEl = document.getElementById(target);
        gsap.to(window, {
            scrollTo: { y: targetEl, offsetY: 150 }
        });
    };

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            const { target } = button.dataset;
            scrollToEl(target);
        });
    });
};

export default initServiceNav;
